import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './Dialog_VariableEditor.scss';
import { __stringify, _keys, arrayIncludesAll, arrayToMap, BadImplementationException, cloneArr, cloneObj, dbObjectToId, deepClone, exists, filterDuplicates, flatArray, MUSTNeverHappenException, removeItemFromArray, Second, sortArray, ThisShouldNotHappenException, ValidationException } from '@nu-art/ts-common';
import { _className, Button, ComponentSync, EditableDBItemV3, Grid, LL_H_C, LL_V_L, ModuleFE_Dialog, openContent, performAction, Show, SimpleListAdapter, ToastBuilder, TS_Checkbox, TS_Dialog, TS_DropDown, TS_Input, TS_Link, TS_PropRenderer, TS_Radio, TS_Tabs } from '@nu-art/thunderstorm-frontend';
import { DBDef_Variable, Empty_NormalRangeExpression, ExpressionType_NormalRange, InRangeExpressionTemplate, perspectives, resolveCPTNav, resolveIcdCode, resolveLoincLink, resolveRxNav, resolveSnomedLink, resolveValueDisplay, Template_BasicNLP, ValType_Time, valueID_No, valueType_SubEnumerated, valueType_SubTime, valueType_Time, variableType_Attribute, variableType_AttributeInstance, variableType_EvidenceOf, variableType_FamilyHistoryOf, variableType_HistoryOf, variableType_Normal, variableType_PrecipitatingFactor, variableType_Recent, variableType_RelievingFactor, } from '@app/hcs-shared';
import { CompoundEnumeratedEditor, CompoundRangeEditor, Editor_TimeValue, NormalRangeEditor } from '../../values/index.js';
import { VariableWrapper } from '../../../../wrappers/index.js';
import { findDuplicateVariableByName, hasDuplicateVariableName } from '../../../../utils.js';
import { QEditableEntryList, QScrollWrapper, QToastContent } from '../../../q-components/index.js';
import { ICONS } from '@app/styles';
import { ConfigKeyFE_SourceTagId, DropDown_Referencable, ModuleFE_Expression, ModuleFE_MacroTag, ModuleFE_MeasurementUnit, ModuleFE_NLPData, ModuleFE_Referencable, ModuleFE_Reference, ModuleFE_Tag, ModuleFE_Value, ModuleFE_Variable, } from '../../../../_entity.js';
import { ValType_CompoundEnumerated, ValType_CompoundRange, ValType_PosNeg, ValType_StandardRange, ValType_YesNo, ValType_YesSuspectedNo, valueID_PosNeg, valueID_YesNo, valueID_YesSuspectedNo, valueType_Enumerated, valueType_Range, valueType_StandardRange, valueType_SubRange, valueType_Tuple, } from '@app/hcs-shared/core';
import { DropDown_MacroTag } from '../../../../_entity/macro-tag/ui-components.js';
import { HttpCodes } from '@nu-art/ts-common/core/exceptions/http-codes';
import { cleanItem_Referencable } from '@app/hcs-shared/hcs-v2';
import { SubEnumeratedEditor } from '../../values/Editors/SubEnumeratedEditor.js';
import { SubTimeEditor } from '../../values/Editors/SubTimeEditor.js';
import { WarningDialog } from '../../../shared-dialogs/index.js';
import { Component_TagEditor } from '../../../shared-components/Component_TagEditor/index.js';
import { Component_AttributeInstanceParents } from '../components/Component_AttributeInstanceParents/Component_AttributeInstanceParents.js';
import { Component_FactorVariableInfo } from '../components/Component_FactorVariableInfo/Component_FactorVariableInfo.js';
import Component_RelationsTable from '../components/Component_RelationsTable/Component_RelationsTable.js';
import { Editor_Referencable } from '../../../../_entity/referencable/Editor_Referencable/Editor_Referencable.js';
const uiValueTypeRange = 'Range';
const uiValueTypeEnumerated = 'Enumerated';
const uiValueTypeYesNo = 'YesNo';
const uiValueTypeYesSuspectedNo = 'YesSuspectedNo';
const uiValueTypePosNeg = 'PosNeg';
const uiValueTypeStandardRange = 'Standard Range';
const uiValueTypeTime = 'Time';
const uiValueTypeSubEnumerated = 'Sub Enumerated';
const uiValueTypeSubTime = 'Sub Time';
const dropdownOptions = [
    uiValueTypeRange,
    uiValueTypeEnumerated,
    uiValueTypeYesNo,
    uiValueTypeYesSuspectedNo,
    uiValueTypePosNeg,
    uiValueTypeStandardRange,
    uiValueTypeTime,
    uiValueTypeSubTime
];
const EditorMap = {
    [valueType_Range]: CompoundRangeEditor,
    [valueType_Enumerated]: CompoundEnumeratedEditor,
    [valueType_StandardRange]: NormalRangeEditor,
    [valueType_Time]: Editor_TimeValue,
    [valueType_SubEnumerated]: SubEnumeratedEditor,
    [valueType_SubTime]: SubTimeEditor,
};
const initialValueData = {
    [uiValueTypeEnumerated]: ValType_CompoundEnumerated,
    [uiValueTypeRange]: ValType_CompoundRange,
    [uiValueTypeStandardRange]: ValType_StandardRange,
    [uiValueTypeYesNo]: ValType_YesNo,
    [uiValueTypeYesSuspectedNo]: ValType_YesSuspectedNo,
    [uiValueTypePosNeg]: ValType_PosNeg,
    [uiValueTypeTime]: ValType_Time,
    [uiValueTypeSubEnumerated]: {},
    [uiValueTypeSubTime]: {},
};
export class Dialog_VariableEditor extends TS_Dialog {
    // ######################## Static ########################
    static defaultProps = {
        dialogId: 'variable-editor',
    };
    static show(selectedCategoryId, variable, initialRef, onVariableSaved) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_VariableEditor, { tagId: selectedCategoryId, variable: variable, initialRefType: initialRef?.refType, initialRefCode: initialRef?.refCode, onVariableSaved: onVariableSaved }, variable?._id),
            closeOverlayOnClick: () => false
        });
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        //Gather Value Options
        state.categoryMap = arrayToMap(ModuleFE_Tag.cache.all(), dbObjectToId);
        state.measurementUnitsMap = arrayToMap(ModuleFE_MeasurementUnit.cache.all(), dbObjectToId);
        state.valuesMap = arrayToMap(ModuleFE_Value.cache.all(), dbObjectToId);
        state.sourceTagId = ConfigKeyFE_SourceTagId.get();
        const getTemplateVariable = () => {
            //Find the group tag
            let groupTag;
            const tag = state.categoryMap[this.props.tagId];
            if (tag.tagIds.length === 0)
                groupTag = tag;
            else
                groupTag = state.categoryMap[tag.tagIds.find(item => state.categoryMap[item].tagIds.length === 0)];
            if (!groupTag)
                throw new BadImplementationException('Gave a tag which is not a group or belongs to no group');
            const tagsIds = [...tag.tagIds, tag._id].filter(i => i !== groupTag._id);
            return {
                name: '',
                tagIds: [{ key: groupTag._id, value: tagsIds }],
                perspective: perspectives[0],
                otherProperties: {},
                _nameInLowercase: '',
                _tagIds: [groupTag._id, ...tagsIds],
                showInAdvisor: true
            };
        };
        //Retain current variable
        state.variable = this.state?.variable || nextProps.variable
            ? cloneObj(nextProps.variable)
            : getTemplateVariable();
        const variableWrapper = new VariableWrapper(state.variable);
        state.uiTags ||= variableWrapper.getUITags();
        state.preDBNlpData ||= variableWrapper.getNlpData() || deepClone(Template_BasicNLP);
        state.preDBReferences ||= variableWrapper.getReferences() || [];
        state.uiAttributeCouplings ||= variableWrapper.getAttributes() || [];
        state.uiValue ||= variableWrapper.getUIValue() || {};
        // Add initial reference if provided (for new variables)
        if (nextProps.initialRefType && nextProps.initialRefCode && !nextProps.variable) {
            const existingRef = state.preDBReferences.find(ref => ref.type === nextProps.initialRefType && ref.data.id === nextProps.initialRefCode);
            if (!existingRef) {
                state.preDBReferences.push({ type: nextProps.initialRefType, data: { id: nextProps.initialRefCode } });
            }
        }
        //Initialize dimensions if value has units
        if (!state.variable.otherProperties?.dimensions && state.uiValue && [valueType_Range,
            valueType_SubRange,
            valueType_StandardRange].includes(state.uiValue.type)) {
            const _value = state.uiValue;
            state.variable.otherProperties.dimensions = ModuleFE_MeasurementUnit.getDimensionForUnit(_value.data?.measurementUnit?.unitAsString || '');
        }
        state.selectedOption = this.state?.selectedOption || this.getOptionsFromValue(state.uiValue);
        if (state.uiValue.type === valueType_StandardRange) {
            const relatedExpression = ModuleFE_Expression.cache.find(expr => expr.associatedVar === state.variable._id
                && expr.expressionType === ExpressionType_NormalRange.dbKey);
            state.editableExpression ??= this.getEditableDBItemV3(state.uiValue, relatedExpression);
        }
        state.editLocked = state.variable.type === variableType_AttributeInstance;
        if (exists(state.variable._id) && !exists(state.connectedReferencable)) {
            const ref = ModuleFE_Referencable.cache.find(ref => !!ref.dbRefs?.find(pointer => pointer.id === state.variable._id));
            if (ref)
                state.connectedReferencable = new EditableDBItemV3(ref, ModuleFE_Referencable);
        }
        return state;
    }
    getEditableDBItemV3(uiValue, relatedExpression) {
        return new EditableDBItemV3(relatedExpression ?? Empty_NormalRangeExpression(uiValue), ModuleFE_Expression);
    }
    // ######################## Logic ########################
    saveVariable = async () => {
        this.setState({ dialogIsBusy: true });
        this.logInfo(`Trying to create variable`, this.state.variable);
        let toastContent;
        const attributes = this.state.uiAttributeCouplings ? cloneArr(this.state.uiAttributeCouplings) : [];
        try {
            ModuleFE_NLPData.validateImpl(this.state.preDBNlpData);
            this.state.preDBReferences.map(ref => ModuleFE_Reference.validateImpl(ref));
            this.state.editableExpression?.validate();
            const hasError = this.state.editableExpression?.hasError();
            // @ts-ignore Hack.. cannot ignore expression validation otherwise
            if (hasError && !(_keys(hasError).length === 1 && hasError['associatedVar']))
                throw new ValidationException('Error validating object');
            //Set data
            this.state.variable.tagIds = VariableWrapper.getTagsForDB(this.state.uiTags);
            const requestBody = {
                preDBVar: this.state.variable,
                uiAttributeCouplings: attributes,
                preDBNlpData: this.state.preDBNlpData,
                preDBReferences: this.state.preDBReferences,
                uiExpression: this.state.editableExpression?.item,
                uiValue: this.state.uiValue,
            };
            //Send request
            this.logInfo(requestBody);
            const variable = await ModuleFE_Variable._v1.createUIVariable(requestBody).executeSync();
            // In range expression must be created in the ui after the variable being created due to indexing issue in the expression pre write doesn't support the transaction
            if (!this.state.variable.inRangeExpression && this.state.uiValue.type === valueType_StandardRange) {
                const dbVar = deepClone(variable.dbVar[0]);
                const inRangeExpression = InRangeExpressionTemplate(dbVar);
                const expr = await ModuleFE_Expression.v1.upsert(inRangeExpression).executeSync();
                dbVar.inRangeExpression = expr._id;
                await ModuleFE_Variable.v1.upsert(dbVar).executeSync();
            }
            this.logInfo(`Created variable`, variable);
            toastContent = QToastContent({
                toastType: 'success',
                content: `Variable ${this.state.variable._id ? 'Updated' : 'Created'} Successfully`
            });
            new ToastBuilder().setContent(toastContent).setDuration(5000).show();
            // call the callback with the saved variable
            const savedVariable = variable.dbVar[0];
            if (savedVariable && this.props.onVariableSaved) {
                this.props.onVariableSaved(savedVariable);
            }
            ModuleFE_Dialog.close();
        }
        catch (e) {
            if (e.responseCode === HttpCodes._4XX.FAILED_VALIDATION.code) {
                this.logError('FAILED_VALIDATION');
                toastContent = QToastContent({
                    toastType: 'error',
                    content: `Variable fields failed validation: ${__stringify(_keys(e.errorResponse.error.result).filter(_key => _key.charAt(0) !== '_').join(', '))}`
                });
                this.logWarning('Validation error result:', e.errorResponse.error.result);
                new ToastBuilder().setContent(toastContent).setDuration(5000).show();
            }
            if (e.responseCode === HttpCodes._4XX.CONFLICT.code) {
                this.logError('Conflicting name');
                toastContent = QToastContent({
                    toastType: 'error',
                    content: `Variable with name already exists!`
                });
                this.logWarning('Validation error result:', e.errorResponse.error.result);
                new ToastBuilder().setContent(toastContent).setDuration(5000).show();
            }
            // if ((e as any).errorResponse.error.exceptionType === 'ValidationException') {
            // 	this.logError('ValidationException');
            // 	toastContent = QToastContent({
            // 		toastType: 'error',
            // 		content: `Variable fields failed validation: ${__stringify((_keys((e as any).errorResponse.error.result) as string[]).filter(_key => _key.charAt(0) !== '_').join(', '))}`
            // 	});
            // 	this.logWarning('Validation error result:', (e as any).errorResponse.error.result);
            // 	new ToastBuilder().setContent(toastContent).setDuration(5000).show();
            // }
            else {
                this.logError(e);
            }
            this.setState({ dialogIsBusy: false });
        }
        finally {
            //todo has-dependencies will move to the defaultOnError listener in ModuleFE_AppModule
            // Need to add validation errors to ModuleFE_AppModule as well
        }
    };
    canBeSaved = () => {
        if (!VariableWrapper.hasSourceSubTags(this.state.uiTags)) {
            // this.logWarning('missing source tag');
            return false;
        }
        if (!this.state.uiValue.type) {
            // this.logWarning('missing value type');
            return false;
        }
        if (!!this.state.variable._id && this.state.uiValue.type && this.state.uiValue.type !== ModuleFE_Value.cache.unique(this.state.uiValue._id)?.type) {
            // this.logWarning(`value types don't match`);
            return false;
        }
        if (hasDuplicateVariableName(this.state.variable)) {
            // this.logWarning('duplicate variable name');
            return false;
        }
        //todo Need to add more rules, maybe call the validator? Though, this is called quite a lot...
        return true;
    };
    getOptionsFromValue(value) {
        if (!value)
            return undefined;
        switch (value.type) {
            case valueType_Tuple: {
                if (value._id === valueID_YesNo)
                    return 'YesNo';
                if (value._id === valueID_PosNeg)
                    return 'PosNeg';
                break;
            }
            case valueType_Enumerated: {
                if (value._id === valueID_YesSuspectedNo)
                    return 'YesSuspectedNo';
                return 'Enumerated';
            }
            case valueType_Range: {
                return 'Range';
            }
            case valueType_StandardRange:
                return 'Standard Range';
            case valueType_Time:
                return 'Time';
            case valueType_SubEnumerated:
                return 'Sub Enumerated';
            case valueType_SubTime:
                return 'Sub Time';
            default:
                return undefined;
        }
    }
    implementValue = (type) => {
        const uiValue = deepClone(initialValueData[type]);
        let editableExpression;
        if (uiValue.type === valueType_StandardRange)
            editableExpression = this.getEditableDBItemV3(uiValue);
        this.setState({ uiValue: uiValue, editableExpression: editableExpression });
        this.forceUpdate();
    };
    canEditValue = () => {
        const option = this.getOptionsFromValue(this.state?.uiValue);
        return ['Enumerated', 'Range', 'Standard Range', 'Time', 'Sub Enumerated', 'Sub Time'].includes(option);
    };
    toastInfo = (message) => {
        new ToastBuilder().setDuration(2 * Second)
            .setContent(QToastContent({ iconKey: 'attention', content: message, toastType: 'info' }))
            .show();
    };
    updateRefLoader = (refType, status) => {
        switch (refType) {
            case 'rxCUI':
                return this.setState({ rxCUILoad: status });
            case 'snomed':
                return this.setState({ snomedLoad: status });
            case 'loinc':
                return this.setState({ loincLoad: status });
            case 'icdCode':
                return this.setState({ icdLoad: status });
            case 'atc':
                return this.setState({ atcLoad: status });
            case 'cpt':
                return this.setState({ cptLoad: status });
        }
    };
    upsertReference = async (refId, refType) => {
        if (this.state.preDBReferences?.find(item => item.type === refType && item.data.id === refId))
            return this.toastInfo(`${refType}: ${refId} - Already assigned to this variable`);
        this.updateRefLoader(refType, true);
        const ref = { type: refType, data: { id: refId } };
        const newRef = await ModuleFE_Reference.v1.upsert(ref).executeSync();
        this.state.preDBReferences.push(newRef);
        this.updateRefLoader(refType, false);
    };
    onDelete = async () => {
        WarningDialog.showDelete({
            title: 'Delete Variable',
            executeButtonText: 'Delete',
            warningMessages: [`Are you sure you want to delete '${this.state.variable.name}'?`],
            onConfirm: async () => {
                this.setState({ dialogIsBusy: true });
                await performAction(async () => {
                    await ModuleFE_Variable._v1.deleteVariable({ variableToDelete: this.state.variable }).executeSync();
                }, {
                    type: 'toast',
                    successContent: _jsx(QToastContent, { toastType: 'success', iconKey: 'v', content: 'Variable Deleted Successfully' }),
                    duration: 10000
                }, this.state.variable.name, false, true);
                this.setState({ dialogIsBusy: false });
                ModuleFE_Dialog.close();
            }
        });
    };
    getFlatTagIds = () => {
        return filterDuplicates(flatArray(this.state.uiTags.map(group => [group.key._id, ...group.value.map(dbObjectToId)])));
    };
    implementMacroTag = (macroTag) => {
        macroTag.tagGroups.forEach(group => {
            let existing;
            //Assign existing uiGroup by key id;
            existing = this.state.uiTags.find(uiGroup => uiGroup.key._id === group.key);
            //No group with this key yet
            if (!existing) {
                const keyTag = ModuleFE_Tag.cache.unique(group.key);
                if (!keyTag)
                    throw new MUSTNeverHappenException(`Could not find tag with id ${group.key}`);
                existing = { key: keyTag, value: [] };
                this.state.uiTags.push(existing);
            }
            group.value.forEach(id => {
                if (existing.value.find(tag => tag._id === id))
                    return;
                const tag = ModuleFE_Tag.cache.unique(id);
                if (!tag)
                    throw new MUSTNeverHappenException(`Could not find tag with id ${id}`);
                existing.value.push(tag);
            });
        });
        this.forceUpdate();
    };
    deleteMacroTag = (macroTag) => {
        macroTag.tagGroups.forEach(group => {
            const existing = this.state.uiTags.find(uiGroup => uiGroup.key._id === group.key);
            if (!existing)
                throw new ThisShouldNotHappenException(`Could not find UITagGroup with key id ${group.key}`);
            existing.value = existing.value.filter(uiTag => !group.value.includes(uiTag._id));
            if (!existing.value.length) {
                removeItemFromArray(this.state.uiTags, existing);
            }
        });
        this.forceUpdate();
    };
    openCreateAttributeInstanceDialog = () => {
        const variableId = this.state.variable._id;
        if (!variableId)
            return;
        const variable = ModuleFE_Variable.cache.unique(variableId);
        if (!variable)
            throw new MUSTNeverHappenException(`Could not find variable for id ${variableId}`);
        Dialog_CreateAttributeInstance.show({ tagId: this.props.tagId, parentVariableId: variableId });
    };
    updateFactorLabel = (variable, value, type) => {
        const base = type === variableType_PrecipitatingFactor ? 'precipitated by' : 'relieved by';
        const variableCompoundValue = ModuleFE_Value.cache.unique(variable.valueId);
        if (!variableCompoundValue)
            throw new MUSTNeverHappenException(`cannot find value with id ${variable.valueId}`);
        if (variableCompoundValue._id === valueID_YesNo)
            return `${base}${value._id === valueID_No ? ' no' : ''} ${variable._nameInLowercase}`;
        return `${base} ${variable._nameInLowercase} - ${resolveValueDisplay(value)}`;
    };
    // ######################## Render ########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("span", { className: "header__title", children: (this.state.variable._id ? 'Edit Variable' : 'Add Variable') + ` - ${this.state.variable.name}` }), _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() })] });
    };
    buttons = () => {
        const leftButtons = [];
        const rightButtons = [
            {
                content: 'Cancel',
                onClick: () => ModuleFE_Dialog.close(),
                disabled: this.state.dialogIsBusy,
            },
            {
                content: 'Save',
                disabled: this.state.dialogIsBusy || !this.canBeSaved(),
                className: _className(this.canBeSaved() && 'desired-action-button'),
                onClick: this.saveVariable,
            }
        ];
        if (this.state.variable._id)
            leftButtons.push({
                content: 'Delete',
                className: 'delete-button',
                disabled: this.state.dialogIsBusy || !this.state.variable._id,
                onClick: this.onDelete,
            });
        return {
            left: leftButtons.length ? leftButtons : undefined,
            right: rightButtons,
        };
    };
    renderBody = () => {
        const tabs = [
            {
                title: 'Variable',
                uid: 'variable',
                content: this.renderVariableTab(),
            },
            {
                title: 'Values',
                uid: 'values',
                content: this.renderValuesTab(),
                disabled: !this.canEditValue(),
            },
            {
                title: 'Attribute Instances',
                uid: 'attribute-instances',
                disabled: this.state.variable.type === variableType_AttributeInstance,
                content: this.renderAttributeInstancesTab,
            },
            {
                title: 'NLP and Other Properties',
                uid: 'nlp-and-other',
                content: this.renderNLPAndOtherTab(),
            },
            {
                title: 'Relations',
                uid: 'relations',
                content: this.renderRelationsTab(),
                disabled: !this.state.uiValue.type
            },
            {
                title: 'HCS v2.0',
                uid: 'hcs-v2.0',
                content: this.renderHCSV2Tab,
            },
        ];
        return _jsx(TS_Tabs, { tabs: tabs });
    };
    //######################## Render - Variable Tab
    renderVariableTab() {
        return _jsxs(LL_H_C, { className: 'match_parent', style: { padding: '20px', gap: '20px' }, children: [_jsxs(LL_V_L, { className: 'dialog__main__section', children: [this.renderVariableName(), this.renderVariableType(), this.renderParents(), this.renderParent(), this.renderFactorVariableInfo(), this.renderShowInAdvisorConfig(), this.renderValuesType(), this.renderHasInRangeIndication(), _jsx(LL_H_C, { className: 'match_width dialog__main__section-item', children: this.renderVariablePerspective() }), _jsxs(Grid, { className: 'dialog__main__section-references', children: [this.renderRefList('snomed', this.state.snomedLoad), this.renderRefList('loinc', this.state.loincLoad), this.renderRefList('icdCode', this.state.icdLoad), this.renderMedicationReference(), this.renderSynonyms(), this.renderRefList('cpt', this.state.cptLoad)] })] }), _jsxs(LL_V_L, { className: 'dialog__main__section', children: [this.renderMacroTags(), this.renderTags()] })] });
    }
    renderVariableName() {
        const isFactor = [variableType_PrecipitatingFactor, variableType_RelievingFactor].includes(this.state.variable.type);
        const duplicate = findDuplicateVariableByName(this.state.variable);
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Variable Name', className: _className('dialog__main__section-item', duplicate && 'has-name-conflict'), children: [_jsx(TS_Input, { disabled: this.state.editLocked || isFactor, id: `add-variable__variable-name`, placeholder: 'Enter Variable Name', type: "text", value: this.state.variable?.name || '', onChange: (value => {
                        this.state.variable.name = value;
                        this.forceUpdate();
                    }) }), duplicate && (_jsxs("div", { className: 'variable-editor__name-conflict', children: ["A variable named \"", duplicate.name, "\" already exists."] }))] });
    }
    renderVariableType() {
        const variable = this.state.variable;
        const values = [variableType_Normal, variableType_Attribute, variableType_PrecipitatingFactor, variableType_RelievingFactor];
        if (exists(variable._id) && !values.includes(variable.type))
            values.push(variable.type);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Variable Type', children: _jsx(TS_Radio, { disabled: exists(variable._id) || this.state.editLocked, values: values, checked: variable.type, groupName: 'variable-type', onCheck: type => {
                    variable.type = type;
                    // if the new variable being created is a factor, set the value to yes-no automatically
                    if ([variableType_PrecipitatingFactor, variableType_RelievingFactor].includes(type)) {
                        // see if label needs an update
                        const variableInfo = variable.variableInfo;
                        if (variableInfo?.variableId && variableInfo?.valueId) {
                            const _var = ModuleFE_Variable.cache.unique(variableInfo.variableId);
                            if (!_var)
                                throw new MUSTNeverHappenException(`cannot find db var with id ${variableInfo.variableId}`);
                            const _val = ModuleFE_Value.cache.unique(variableInfo.valueId);
                            if (!_val)
                                throw new MUSTNeverHappenException(`cannot find db value with id ${variableInfo.valueId}`);
                            variable.name = this.updateFactorLabel(_var, _val, type);
                        }
                        return this.implementValue(uiValueTypeYesNo);
                    }
                    // clean variable factor info if exists
                    if (variable.variableInfo) { // @ts-ignore - this must be ignored otherwise will save redundant data
                        delete variable.variableInfo;
                    }
                    this.forceUpdate();
                } }) });
    }
    renderValuesType() {
        if ([variableType_RelievingFactor, variableType_PrecipitatingFactor].includes(this.state.variable.type))
            return;
        const adapter = SimpleListAdapter(dropdownOptions, (item) => _jsx("div", { children: item.item }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Values Type', className: 'dialog__main__section-item', children: _jsx(TS_DropDown, { disabled: !!this.state.variable._id || (!!this.state.variable._id && this.state.uiValue.type && this.state.uiValue.type === ModuleFE_Value.cache.unique(this.state.uiValue._id)?.type), adapter: adapter, selected: this.getOptionsFromValue(this.state.uiValue), onSelected: this.implementValue }) });
    }
    renderMedicationReference = () => {
        return _jsxs(_Fragment, { children: [this.renderRefList('rxCUI', this.state.rxCUILoad), this.renderRefList('atc', this.state.atcLoad)] });
    };
    renderVariablePerspective() {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Perspective', className: 'dialog__main__section-item', children: _jsx(TS_Radio, { disabled: this.state.editLocked, className: 'label-radio', values: [...perspectives], groupName: 'perspectives', checked: this.state.variable?.perspective, onCheck: (value) => {
                    this.state.variable.perspective = value;
                    this.forceUpdate();
                } }) });
    }
    renderShowInAdvisorConfig = () => {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Advisor Config', children: _jsx(TS_Checkbox, { checked: this.state.variable.showInAdvisor, disabled: this.state.editLocked || this.state.dialogIsBusy, onCheck: (value) => {
                    this.state.variable.showInAdvisor = value;
                    this.forceUpdate();
                }, children: "Show this variable in the advisor" }) });
    };
    renderRefLink = (ref) => {
        const className = _className('ref-link', !this.state.editLocked && 'border-left');
        // resolve link
        let link;
        switch (ref.type) {
            case 'snomed':
                link = resolveSnomedLink(ref.data.id);
                break;
            case 'icdCode':
                link = resolveIcdCode(ref.data.id);
                break;
            case 'loinc':
                link = resolveLoincLink(ref.data.id);
                break;
            case 'rxCUI':
                link = resolveRxNav('RXCUI', ref.data.id);
                break;
            case 'atc':
                link = resolveRxNav('ATC', ref.data.id);
                break;
            case 'cpt':
                link = resolveCPTNav(ref.data.id);
        }
        return _jsx(TS_Link, { url: link, className: className, target: '_blank', children: ref.data.id });
    };
    resolveRefListLabel = (refType) => {
        switch (refType) {
            case 'rxCUI':
                return 'RxCUI Codes:';
            case 'icdCode':
                return `ICD Codes:`;
            case 'atc':
                return 'ATC Codes:';
            case 'cpt':
                return 'CPT Codes';
            default:
                return `${refType.charAt(0).toUpperCase()}${refType.slice(1)} Ids`;
        }
    };
    renderRefList(refType, isLoading) {
        const refs = this.state.preDBReferences?.filter(i => i.type === refType);
        return _jsx(TS_PropRenderer.Vertical, { label: () => this.resolveRefListLabel(refType), className: 'dialog__main__section-item reference', children: _jsx(QEditableEntryList, { disabled: this.state.editLocked, entries: refs, removeEntry: _ref => {
                    this.setState({
                        preDBReferences: this.state.preDBReferences.filter(item => item.data.id !== _ref.data.id
                            ? true
                            : item.type !== _ref.type)
                    });
                    this.forceUpdate();
                }, addEntry: val => this.upsertReference(val, refType), isLoading: isLoading, pasteOnly: true, render: this.renderRefLink, tailRenderer: this.renderReferenceWarning, placeholder: '+' }) });
    }
    renderTags() {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Tags', className: 'dialog__main__section-item tags', children: _jsx(QScrollWrapper, { children: _jsx(Component_TagEditor
                // disableEdit={this.state.editLocked}
                , { 
                    // disableEdit={this.state.editLocked}
                    tags: this.state.uiTags, mandatoryRootTag: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id, onChange: () => this.forceUpdate() }) }) });
    }
    renderSynonyms = () => {
        const synonyms = this.state.preDBNlpData?.synonyms;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Synonyms', className: 'dialog__main__section-item synonyms', children: _jsx(QEditableEntryList, { entries: synonyms, pasteOnly: false, placeholder: '+', disabled: this.state.editLocked }) });
    };
    renderReferenceWarning = (ref) => {
        const variablesWithThisRef = [];
        const variables = ModuleFE_Variable.cache.filter(v => v._id !== this.state.variable._id && !!v.referenceIds.find(i => ModuleFE_Reference.cache.unique(i)?.data?.id.trimEnd() === ref?.data.id.trimEnd()));
        variablesWithThisRef.push(...variables.map(i => i.name));
        if (!variablesWithThisRef.length)
            return;
        const renderer = () => _jsxs(LL_V_L, { className: 'reference-used-tooltip', children: [_jsx("div", { className: 'reference-used-tooltip__title', children: "This id appears in other variables" }), _jsx(LL_H_C, { className: 'reference-used-tooltip__ref', children: _jsx("div", { className: 'reference-used-tooltip__ref-names', children: variablesWithThisRef.join(', ') }) })] });
        return _jsx(ICONS.information.component, { ...openContent.tooltip.top('info-tool-tip', renderer), className: 'entry-tail' });
    };
    renderMacroTags = () => {
        const tagIds = this.getFlatTagIds();
        const macroTags = ModuleFE_MacroTag.cache.filter(macroTag => !!macroTag.__tagIds && arrayIncludesAll(tagIds, macroTag.__tagIds));
        const existingIds = macroTags.map(dbObjectToId);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Macro Tags', className: 'dialog__main__section-item', children: _jsxs(LL_H_C, { className: 'macro-tags', children: [macroTags.map(macroTag => _jsx(LL_H_C, { className: 'macro-tag', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: !this.state.editLocked, children: _jsx(ICONS.x.component, { onClick: () => this.deleteMacroTag(macroTag) }) }), _jsx(Show.If, { condition: true, children: macroTag.label })] }) }, macroTag._id)), _jsx(DropDown_MacroTag.selectable, { disabled: this.state.editLocked, queryFilter: macroTags => !existingIds.includes(macroTags._id), onSelected: this.implementMacroTag })] }) });
    };
    renderParents = () => {
        const variable = this.state.variable;
        if (variable.type !== variableType_AttributeInstance)
            return;
        const parentVariableId = variable.parents.variableId;
        const parentAttributeId = variable.parents.attributeId;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Parent Variables', children: _jsx(Component_AttributeInstanceParents, { parentVariableId: parentVariableId, parentAttributeId: parentAttributeId, onVariableClick: variable => Dialog_VariableEditor.show(this.props.tagId, variable) }) });
    };
    renderParent = () => {
        const types = [variableType_HistoryOf, variableType_FamilyHistoryOf, variableType_EvidenceOf, variableType_Recent];
        const variable = this.state.variable;
        if (!types.includes(variable.type))
            return;
        const parentId = variable.parentId;
        const parentVariable = ModuleFE_Variable.cache.unique(parentId);
        if (!parentVariable)
            throw new MUSTNeverHappenException(`Displaying a child variable with no connected parent variable, id ${parentId}`);
        return _jsx(TS_PropRenderer.Vertical, { label: 'Parent Variable', children: _jsx("div", { className: 'variable-editor__parent-link', onClick: () => Dialog_VariableEditor.show(this.props.tagId, parentVariable), children: parentVariable.name }) });
    };
    renderFactorVariableInfo = () => {
        const variable = this.state.variable;
        if (![variableType_PrecipitatingFactor, variableType_RelievingFactor].includes(variable.type))
            return;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Factor Info', children: _jsx(Component_FactorVariableInfo, { disabled: exists(variable._id), selectedVariableId: variable?.variableInfo?.variableId, selectedValueId: variable?.variableInfo?.valueId, valueSelectionCallback: (value) => {
                    const factorVar = ModuleFE_Variable.cache.unique(variable?.variableInfo?.variableId);
                    if (!factorVar)
                        throw new MUSTNeverHappenException(`cannot find variable with id ${variable?.variableInfo?.variableId}`);
                    variable.variableInfo.valueId = value._id;
                    variable.name = this.updateFactorLabel(factorVar, value, variable.type);
                    this.forceUpdate();
                }, variableSelectionCallback: _variable => {
                    // @ts-ignore - in case I which variable I must remove the value so ignore is a must
                    variable.variableInfo = { variableId: _variable._id, valueId: undefined };
                    // @ts-ignore - again must ignore to keep reasonable behaviour of the editor
                    delete variable.name;
                    this.forceUpdate();
                }, onVariableClick: variable => Dialog_VariableEditor.show(this.props.tagId, variable) }) });
    };
    renderHasInRangeIndication = () => {
        if (!this.state.variable.inRangeExpression)
            return;
        const expression = ModuleFE_Expression.cache.unique(this.state.variable.inRangeExpression);
        if (!expression)
            throw new MUSTNeverHappenException(`cannot resolve expression with id ${this.state.variable.inRangeExpression}`);
        return _jsxs(LL_H_C, { className: 'in-range-expression-label', children: ["In Range Expression Created", _jsx(ICONS.v.component, {})] });
    };
    //######################## Render - Values Tab
    renderValuesTab() {
        const type = this.state.uiValue?.type;
        const allowedTypes = [valueType_Enumerated,
            valueType_Range,
            valueType_StandardRange,
            valueType_Time,
            valueType_SubEnumerated,
            valueType_SubTime];
        if (!type || !allowedTypes.includes(type))
            return _jsxs("div", { className: 'edit-not-allowed', children: ["Edit not allowed for value of type ", type] });
        // this.logInfo('-----uiValue!!!!!------', this.state.uiValue);
        // @ts-ignore
        const Renderer = EditorMap[type];
        return _jsx(Renderer, { editable: this.state.editableExpression, value: this.state.uiValue });
    }
    //######################## Render - Nlp & Other Tab
    renderNLPAndOtherTab() {
        return _jsxs(LL_V_L, { className: 'dialog__main nlp-and-other-tab', style: { padding: '20px' }, children: [this.renderDimensions(), this.renderSpecimen()] });
    }
    renderDimensions() {
        const dimensions = this.state.variable.otherProperties?.dimensions;
        return _jsxs(LL_V_L, { className: 'dialog__main__section-item', children: [_jsx("div", { className: 'dialog__field-title', children: "Dimensions" }), _jsx("div", { className: 'dialog__field-content', children: dimensions })] });
    }
    renderSpecimen() {
        const specimen = this.state.variable.otherProperties?.specimen;
        return _jsxs(LL_V_L, { className: 'dialog__main__section-item', children: [_jsx("div", { className: 'dialog__field-title', children: "Specimen" }), _jsx("div", { className: 'dialog__field-content', children: specimen })] });
    }
    renderRelationsTab() {
        const variableValue = ModuleFE_Value.cache.find((v) => {
            return v._id ===
                this.state.uiValue._id;
        });
        if (!variableValue)
            return _jsx("div", { className: 'match_parent', children: "value not found" });
        return _jsx(Component_RelationsTable, { variable: this.state.variable, value: variableValue });
    }
    //######################## Render - Attribute Instances Tab
    renderAttributeInstancesTab = () => {
        const key = this.state.variable.type === variableType_Normal ? 'variableId' : 'attributeId';
        const instances = ModuleFE_Variable.cache.filter(variable => variable.type === variableType_AttributeInstance
            && variable.parents[key] === this.state.variable._id);
        sortArray(instances, instance => instance._nameInLowercase);
        return _jsx(LL_V_L, { className: 'attribute-instances-tab', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: this.state.variable.type === variableType_Normal, children: _jsx(Button, { variant: 'secondary', onClick: this.openCreateAttributeInstanceDialog, children: "Create Attribute Instance" }) }), _jsx(Show.If, { condition: !!instances.length, children: _jsx(TS_PropRenderer.Vertical, { label: 'Existing Instances', children: _jsx(QScrollWrapper, { children: instances.map(instance => {
                                    return _jsx("div", { onClick: () => Dialog_VariableEditor.show(this.props.tagId, instance), children: instance.name }, instance._id);
                                }) }) }) })] }) });
    };
    //######################## Render - HCS V2 Tab
    renderHCSV2Tab = () => {
        const variableId = this.state.variable._id;
        if (!variableId)
            return;
        const editable = this.state.connectedReferencable;
        if (!editable)
            return _jsxs(LL_H_C, { children: [_jsx(Button, { variant: 'primary', onClick: () => {
                            const newReferencable = deepClone(cleanItem_Referencable);
                            newReferencable.dbRefs.push({ dbKey: DBDef_Variable.dbKey, id: variableId });
                            this.setState({ connectedReferencable: new EditableDBItemV3(newReferencable, ModuleFE_Referencable) });
                        }, children: "New Referencable" }), _jsx(DropDown_Referencable.selectable, { selected: undefined, placeholder: 'Connect Referencable', onSelected: async (ref) => {
                            const toEdit = deepClone(ref);
                            if (!toEdit.dbRefs)
                                toEdit.dbRefs = [];
                            toEdit.dbRefs.push({ dbKey: DBDef_Variable.dbKey, id: variableId });
                            try {
                                await ModuleFE_Referencable.v1.upsert(toEdit).executeSync();
                                this.setState({ connectedReferencable: new EditableDBItemV3(toEdit, ModuleFE_Referencable) });
                            }
                            catch (err) {
                                this.logError(err);
                            }
                        } })] });
        return _jsx(Editor_Referencable, { editable: editable });
    };
}
export class Dialog_CreateAttributeInstance extends ComponentSync {
    static show(props) {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_CreateAttributeInstance, { ...props }), closeOverlayOnClick: () => false });
    }
    renderHeader = () => {
        return _jsxs(LL_H_C, { className: 'create-attribute-instance__header', children: [_jsx("div", { className: 'create-attribute-instance__header__title', children: "Create Attribute Instance" }), _jsx(ICONS.x.component, { onClick: () => {
                        ModuleFE_Dialog.close();
                    } })] });
    };
    render() {
        return _jsxs(LL_V_L, { id: 'dialog__create-attribute-instance', children: [this.renderHeader(), _jsx(Component_AttributeInstanceParents, { parentVariableId: this.props.parentVariableId, onAttributeSelected: async (attribute) => {
                        try {
                            const response = await ModuleFE_Variable._v1.createAttributeInstance({
                                parentVariableId: this.props.parentVariableId,
                                parentAttributeId: attribute._id,
                            }).executeSync();
                            //Close dialog twice: 1. attribute instance creation dialog, 2. this dialog
                            ModuleFE_Dialog.close();
                            ModuleFE_Dialog.close();
                            Dialog_VariableEditor.show(this.props.tagId, response.variable);
                        }
                        catch (err) {
                            this.logError(err);
                        }
                    } })] });
    }
}
//# sourceMappingURL=Dialog_VariableEditor.js.map